var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58075 0 0 3.58075 0 8C0 12.4193 3.58075 16 8 16C12.4193 16 16 12.4193 16 8C16 3.58075 12.4193 0 8 0ZM5.68321 11.7598L4.00003 11.9934L4.24323 10.3102L9.40794 5.14229L10.8607 6.58547L5.68321 11.7598ZM11.1551 6.29432L9.71194 4.85114L10.5567 4.00635L11.9999 5.44953L11.1551 6.29432Z",
    fill: "black",
    fillOpacity: 0.69
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.3512685265a806f1b58f0ca66351b278.svg";
export { ForwardRef as ReactComponent };